<template>
    <div v-if="otherProducts.length">
        <!-- <OtherParkingLotsSection v-editable="blok" :products="otherProducts" :blok="blok" /> -->
        <AprProductsCarousel :blok="blok" :products="otherProducts" :section-config="sectionConfig" />
    </div>
</template>

<script setup lang="ts">
import AprProductsCarousel from '~/components/sections/AprProductsCarousel.vue';
// import OtherParkingLotsSection from '../components/sections/parking/OtherParkingLotsSection.vue';
import type { IOtherPortParkingConfig } from '@nuxt-monorepo/ui/types/components/Parking';
import type { IProductsSectionConfig } from '~/../types/ProductsCarousel';
import type { IAirportProducts, IParkingProduct } from '@nuxt-monorepo/ui/types';

const { products, blok } = defineProps<{ blok: IOtherPortParkingConfig; products: IAirportProducts }>();
const otherProducts = computed(() => {
    return Array.isArray(products.parking)
        ? products.parking.filter((product: IParkingProduct) => !product.service)
        : [];
});

const sectionConfig: IProductsSectionConfig = {
    title: 'title',
    subtitle: {
        subtitleName: 'subtitle',
        subtitleType: 'RichText',
    },
    cardType: 'ParkingLotProductCard',
};
</script>
